//
// Besselian Elements for Solar Eclipses from:
//   "Five Millennium Canon of Solar Eclipses: -1999 to +3000",
//      Fred Espenak and Jean Meeus, NASA/TP-2006-214141, October 2006
//
// eslint-disable-next-line @typescript-eslint/naming-convention
export function SE2026(): number[] {
  return [
    // 2026  8 12
    // 2461265.241039,  18.0,  -4.0,   4.0,    75.4,    75.4,
    // 0.4755140,   0.5189249, -7.730e-05, -8.040e-06,
    // 0.7711830,  -0.2301680, -1.246e-04,  3.770e-06,
    // 14.7966700,  -0.0120650, -3.000e-06,
    // 88.7477875,  15.0030899,  0.000e-00,
    // 0.5379550,   0.0000939, -1.210e-05,
    // -0.0081420,   0.0000935, -1.210e-05,
    // 0.0046141,   0.0045911
    // new elements from https://nso.edu/maps/v2/_js/20260812/besselian.js
    2461265.241032,  18.0,  -4.0,   4.0,    71.4, 71.4,
    0.47559288,    0.51892877,   -0.00007733,   -0.00000879,
    0.77116090,   -0.23016642,   -0.00012455,    0.00000372,
    14.79666901,   -0.01206477,   -0.00000274,
    88.74776459,   15.00309277,    0.00000519,
    0.53795421,    0.00009396,   -0.00001209,
    -0.00814245,    0.00009348,   -0.00001206,
    0.00461406,    0.00459108

  ];
}
 
